import React, { useCallback, useEffect, useState } from 'react';
import style from './articleView.module.scss';
import { Scrollbars } from "react-custom-scrollbars";
import { saveAs } from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';
import DOMPurify from 'dompurify'; // 引入DOMPurify库
import moment from 'moment';
import { formatCount } from '../../../../../../../../utils';
import dept from './images/dept.png';
import time from './images/time.png';
import viewCount from './images/viewcount.png';
import collected from './images/collected.png';
import collection from './images/collection.png';


const ArticleView = (props) => {
  const { allFolder, data, cancelCollect, saveArticle } = props;
  const {
    positionContentVo,
    collectFolderId,
    collectFolderName,
    cmSiteContent } = data;
  const { contentId,
    positionTypeId,
    count,
    url,
    publishTime,
    title,
    positionName,
    createDeptName,
    logo,
    collect } = positionContentVo || {};
  const [isCollect, setIsCollect] = useState();

  useEffect(() => {
    setIsCollect(collect);
  }, [contentId, collect]);

  const formatContent = useCallback(() => {
    let content = ''
    if (cmSiteContent) {
      content = cmSiteContent.replace(/<img(.*?)>/g, function (match, p1) {
        if (p1.includes('style')) {
          return match.replace('style="', 'style="max-width:100%;');
        } else {
          return match.replace('>', ' style="max-width:100%;">');
        }
      })
    }
    return content;
  }, [cmSiteContent]);

  const downloadWord = useCallback(async () => {
    try {
      const cleanContent = DOMPurify.sanitize(cmSiteContent); // 使用DOMPurify净化HTML
      const processedContent = await processHtmlForWord(cleanContent);
      const blob = await htmlDocx.asBlob(processedContent);
      saveAs(blob, `${title}.docx`);
    } catch (error) {
      console.error('Error downloading Word:', error);
    }
  }, [cmSiteContent]);

  const processHtmlForWord = useCallback(async (htmlContent) => {
    const virtualElement = document.createElement('div');
    virtualElement.innerHTML = htmlContent;

    const imgElements = virtualElement.querySelectorAll('img');
    const promises = Array.from(imgElements).map(img => processImage(img));
    await Promise.all(promises);

    return virtualElement.innerHTML;
  }, []);

  const processImage = useCallback(async (img) => {
    const currentSrc = img.getAttribute('src');
    if (currentSrc && currentSrc.startsWith('/storage')) {
      const image = new Image();
      image.src = window.location.origin + currentSrc;
      return new Promise((resolve, reject) => {
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const newWidth = image.width * 0.5;
          const newHeight = image.height * 0.5;
          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(image, 0, 0, newWidth, newHeight);
          img.setAttribute('src', canvas.toDataURL('image/png'));
          img.setAttribute('width', newWidth);
          img.setAttribute('height', newHeight);
          resolve();
        };
        image.onerror = reject;
      });
    }
  }, []);

  // 收藏
  const saveArticleHandler = useCallback((params) => {
    saveArticle(params);
  }, [allFolder]);

  return (
    <div className={style.articleViewContainer}>
      <div className={style.titleArea}>
        <div>
          <h1>{title}</h1>
        </div>
        <div className={style.actionArea}>
          <div className={style.statusArea} style={{ flex: 'auto' }}>
            <span>
              <img src={viewCount} alt="" />
              {formatCount(count)}
            </span>
            <span>
              <img src={time} alt="" />
              {moment(publishTime).format('YYYY-MM-DD HH:mm:ss')}
            </span>
            <span>
              <img src={dept} alt="" />
              {createDeptName}
            </span>
            <span>
              <img src={logo} alt="" />
              {positionName}
            </span>
          </div>
          <div style={{ width: '280px' }}>
            <button onClick={() => {
              if (isCollect) {
                cancelCollect({
                  contentId, collectFolderId, collectFolderName, callBack: () => {
                    setIsCollect(false);
                  }
                });
              } else {
                saveArticleHandler({
                  collectFolderId, positionContentVo, collectFolderName, callBack: () => {
                    setIsCollect(true);
                  }
                })
              }
            }}>
              <img style={{ width: '20px', height: '20px', transform: 'translate(-5px, -2px)' }} src={isCollect ? collected : collection} alt="" />
              {isCollect ? '已收藏' : '收藏'}
            </button>
            <button onClick={() => {
              window.open(url);
            }}>原文链接</button>
            <button onClick={() => {
              downloadWord();
            }}>下载</button>
          </div>
        </div>
        {/* 有标签时再显示这个，标签暂时还没有 */}
        {/* <div className={style.actionArea}>
            <div style={{ flex: 'auto' }}>

            </div>
            <div style={{ width: '280px' }}>
              <button onClick={() => {
                if (isCollect) {
                  cancelCollect({
                    contentId, collectFolderId, collectFolderName, callBack: () => {
                      setIsCollect(false);
                    }
                  });
                } else {
                  saveArticleHandler({
                    collectFolderId, positionContentVo, collectFolderName, callBack: () => {
                      setIsCollect(true);
                    }
                  })
                }
              }}>
                <img style={{ width: '20px', height: '20px', transform: 'translate(-5px, -2px)' }} src={isCollect ? collected : collection} alt="" />
                {isCollect ? '已收藏' : '收藏'}
              </button>
              <button onClick={() => {
                window.open(url);
              }}>原文链接</button>
              <button onClick={() => {
                downloadWord();
              }}>下载</button>
            </div>
          </div> */}
      </div>
      <div className={style.contentArea}>
        <Scrollbars style={{ height: '100%' }} autoHide width={'100%'}>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formatContent()) }}></div>
        </Scrollbars>
      </div>
    </div>
  )
}

export default ArticleView;